import React from 'react';
import Grid from '@material-ui/core/Grid';
// import Delete from '@material-ui/icons/Delete';
// import Edit from '@material-ui/icons/Edit';
// import ButtonBase from '@material-ui/core/ButtonBase';
import helpers from '../helpers';
import Typography from '@material-ui/core/Typography';
import { nodeKeysLabel } from "../../../../../config/common";

/*

data: {label: "default", uuid: "nLwHAb4pN9VG2J6nNukYRE", type: "http2_delegate"}
id: "external_function-nLwHAb4pN9VG2J6nNukYRE"
position: {x: 418, y: 146}
type: "external_function"

children: (4) [{…}, {…}, {…}, {…}]
data: {label: "default", uuid: "nLwHAb4pN9VG2J6nNukYRE", type: "http2_delegate"}
id: "external_function-nLwHAb4pN9VG2J6nNukYRE"
isConnectable: true
isDragging: false
selected: true
sourcePosition: undefined
targetPosition: undefined
type: "external_function"
xPos: 418
yPos: 146

*/

const NodeWrapper = (props) => {
  const nodeData = props.data != undefined ? props.data : '';
  const title = props?.data?.subType !== undefined && props?.data?.subType !== '' ? nodeKeysLabel[props?.data?.subType] : helpers.nodeKeysLabel[props.type];
  const nodeTitle = props?.data?.label || null;
  return (
    <>
      {/* {title !== undefined ? <ToolTip title={<AllowedConnections title={title} nodeTitle={nodeTitle} type={props.type} />}> */}
      {/* {title !== undefined ? <ToolTip title={<>{nodeData?.label}<br />{`(${title})`}</>}>

        <div>{props.children}</div>
      </ToolTip> : <div>{props.children}</div>} */}
      <div>{props.children}</div>
    </>
  );
};

export default NodeWrapper;

const trimFunc = (str, length) => {
  let trimmedString = str;
  if (length && str && str.length > length) trimmedString = str.slice(0, length) + '...';
  return trimmedString;
};

export const Title = ({ title = '', icon = null, noStrip = false }) => {

  // console.log({title,noStrip})

  return (
    <Grid container direction="column" justify="space-between" alignItems="center" className='ide-hbx-node-label'>
      <Typography style={{ wordWrap: 'break-word' }} variant="body2">
        {noStrip ? title : trimFunc(title, 40)}
      </Typography>
    </Grid>
  );
};

/*

   {nodeClicked && (
        <Grid style={{position: 'absolute', top: -15, right: '50%', height: 30, backgroundColor: '#fff'}}>
          <Grid container direction="row">
            {!noEdit && (
              <ButtonBase style={{padding: 3}}>
                <Edit color="primary" />
              </ButtonBase>
            )}
            <ButtonBase style={{padding: 3}} onClick={onDelete}>
              <Delete color="error" />
            </ButtonBase>
          </Grid>
        </Grid>
      )}
    


*/
